exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SkeletonTable_table-body_13Eu {\n  margin-top: 24px;\n\n  width: 100%;\n}\n\n  .SkeletonTable_table-body__row_Ml_0 {\n    width: 100%;\n    height: 44px\n  }\n\n  .SkeletonTable_table-body__row_Ml_0:not(:last-child) {\n  margin-bottom: 10px;\n}\n\n  .SkeletonTable_table-body__head_24XT {\n    margin-bottom: 14px;\n\n    width: 100%;\n    height: 16px;\n  }\n", ""]);

// exports
exports.locals = {
	"table-body": "SkeletonTable_table-body_13Eu",
	"table-body__row": "SkeletonTable_table-body__row_Ml_0",
	"table-body__head": "SkeletonTable_table-body__head_24XT"
};